import React from "react";
import "./Layout.css";
import { ToastContainer } from "react-toastify";
import Header from "../Header/Header";
import Sidebar from "../Sidebar/Sidebar";
import { Outlet } from "../../hooks/useRouter";

const Layout = () => {
  return (
    <>
      <ToastContainer closeButton={true} autoClose={1000} position="top-right" />

      <div className="layout-root">
        {/* Sidebar — static, no toggle */}
        <div className="layout-sidebar-section">
          <Sidebar />
        </div>

        {/* Right: header + content */}
        <div className="layout-body">
          <div className="layout-header-section">
            <Header />
          </div>

          <main className="layout-content-section">
            <Outlet />
          </main>
        </div>
      </div>
    </>
  );
};

export default Layout;
